<child-header title="Delete confirmation" (closeEvent)="onNoClick()"></child-header>
<div class="mat-dialog-body">
  <div mat-dialog-content style="text-align: center">
    <h4>Are you sure?</h4>
    <p>Do you want to remove this {{data.type}}?</p>
  </div>
  <div mat-dialog-actions>
    <button mat-button class="button button-red button-mid button-left" (click)="onNoClick()">Cancel</button>
    <button mat-button class="button button-red button-mid" (click)="confirmDelete()">Delete</button>
  </div>
</div>